// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { orderUploadStyles } from "@awc/Overrides/Components/OrderUpload";
import { constants } from "@awc/XDL/constants";
import { color, xScreen } from "@awc/XDL/Utilities";
import { css } from "styled-components";

orderUploadStyles.boxWrapper = {
    css: css`
        margin-top: 15px;
        padding: 15px;
        border: 1px solid ${color("common.border")};
        display: flex;
        flex-direction: column;
    `,
};

orderUploadStyles.uploadFileButton = {
    css: css`
        float: right;
    `,
};

orderUploadStyles.cancelUploadButton = {
    variant: "secondary",
    css: css`
        float: right;
    `,
};

orderUploadStyles.uploadFileButtonLabel = {
    css: css`
        font-size: 15px;
        font-weight: bold;
        color: ${color("common.white")};
    `,
};

orderUploadStyles.buttonsWrapper = {
    css: css`
        gap: 15px;
        display: flex;
        flex-direction: row-reverse;
        ${xScreen("lte", constants.myAccountListPageFilter.breakpoints.xSmall)} {
            flex-direction: column;
        }
    `,
};
